<template>
  <div class="relative">
    <nav class="px-2 md:px-0 py-2">
      <div class="md:flex justify-between items-center">
        <div class="">
          <div class="hidden md:flex text-sx">
            <router-link :to="{name:'home'}">Home</router-link>
          </div>
          <div class="text-xl">
            Dashboard
          </div>
        </div>
        <div class="">
          <div class="md:flex">
            <div class="">
              <multiselect v-model="filters.venues" placeholder="Networks" :multiple="true"
                           track-by="id" :options="venues" label="name"
                           :taggable="true">
              </multiselect>
            </div>
            <div class="md:ml-2 mt-2 md:mt-0" style="z-index: 0">
              <date-range-picker
                  ref="dateRange"
                  v-model="filters.dateRange"
                  :opens="picker.opens"
                  :locale-data="picker.locale"
                  :minDate="picker.minDate"
                  :maxDate="picker.maxDate"
                  :singleDatePicker="picker.singleDatePicker"
                  :timePicker="picker.timePicker"
                  :timePicker24Hour="picker.timePicker24Hour"
                  :showWeekNumbers="picker.showWeekNumbers"
                  :showDropdowns="picker.showDropdowns"
                  :autoApply="picker.autoApply"
                  :linkedCalendars="picker.linkedCalendars"
                  :dateFormat="picker.dateFormat">
              </date-range-picker>
            </div>
            <!-- Export Button -->
            <div class="md:ml-2 mt-2 md:mt-0">
              <button @click="exportData" class="btn btn-success">Export Data</button>
            </div>
          </div>
        </div>
      </div>
    </nav>
    <div class="py-4">
      <div class="flex flex-col">
        <DashboardSwitcher v-for="dashboard in dashboards.content"
                           :key="dashboard.id"
                           :filters="filters"
                           :org-id="orgId"
                           :edit-mode="editMode"
                           :dashboard="dashboard"/>
      </div>
    </div>
  </div>
</template> 
<script>
import GraphQl from "../../services/graphql.service";
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import moment from "moment";
import DashboardSwitcher from "@/modules/Dashboards/DashboardSwitcher";

export default {
  name: "Home",
  components: {DashboardSwitcher, DateRangePicker},
  props: { 
    orgId: String
  },
  data() {
    return {
      editMode: false,
      summary:[],
      dashboards: {
        content: [],
      },
      filters: {
        dateRange: {startDate: moment().startOf("day").toDate(), endDate: moment().endOf("day").toDate()},
        venues: [],
      },
      picker: {
        opens: "left",
        timePicker: false,
        autoApply: false,
        linkedCalendars: true,
        maxDate: moment(moment.now()).format("YYYY-MM-DD"),
        locale: {
          format: 'dd/mm/yyyy',
          direction: "ltr",
          separator: " - ",
          applyLabel: "Apply",
          cancelLabel: "Cancel",
          weekLabel: "W",
          customRangeLabel: "Custom Range",
          daysOfWeek: moment.weekdaysMin(),
          monthNames: moment.monthsShort(),
          firstDay: 1
        }
      },
      venues: []
    }
  },
  mounted() {
    this.$root.$on("edit_dashboard", (editMode) => {
      this.editMode = editMode;
      if (editMode)
        this.initEditing();
      else
        this.dashboards.content = this.del(this.dashboards, "add_dashlet")
    });
    this.$root.$on("remove_dashlet", (dashboardId) => {
      this.dashboards.content = this.del(this.dashboards, dashboardId)
      this.saveDashboard();
    });
    this.$root.$on("add_dashlet", (dashboard) => {
      this.dashboards.content.push(dashboard);
      this.swap(dashboard.id, -1)
      this.saveDashboard();
    });
    this.$root.$on("moveup_dashlet", (dashboardId) => {
      this.swap(dashboardId, -1)
      this.saveDashboard();
    });
    this.$root.$on("movedown_dashlet", (dashboardId) => {
      this.swap(dashboardId, 1)
      this.saveDashboard();
    });

    GraphQl.sendRequest("{organization(id: \"" + this.orgId + "\"){venues{id name}}}")
        .then(response => {
              this.venues = response.organization.venues;
            }
        )
    GraphQl.sendRequest("{profile {dashboard}}")
        .then(response => {
              if (response.profile.dashboard !== '' && response.profile.dashboard != null){

                this.dashboards = JSON.parse(response.profile.dashboard);             
                  
              } else {
                this.saveDashboard(); 
              }
              if (this.dashboards.content && this.dashboards.content.length === 0)
                this.initEditing()
            }
        )
        let v = [];
      this.filters.venues.forEach(function (venue) {
        v.push(venue.id);
      });

    let params = (this.filters.venues.length > 0 ? 'venues:["' + v.join('","') + '"],' : '') +
          'startDate: "' +  moment(this.filters.dateRange.startDate).format("YYYY-MM-DD 00:00:00") + '", ' +
          'endDate: "' + moment(this.filters.dateRange.endDate).format("YYYY-MM-DD 23:59:59") + '"';

      GraphQl.sendRequest('{organization(id:"' + this.orgId + '") {accessPointsCount venuesCount connectionsCount(' + params + ')' +
          ' customersCount(' + params + ') onlineConnectionsCount(' + params + ')}' +
          'aggregateUsageSummary(' + params + '){formattedUpload formattedDownload formattedBandwidth new_customers repeat_customers connections footfall dwell_time abandoned avg_dwell_time}}')
          .then(response => {
            this.organization = response.organization;
            this.summary = response.aggregateUsageSummary;
          })          
  },
  methods: { 
    saveDashboard() {
      this.dashboards.content = this.del(this.dashboards, "add_dashlet")
      GraphQl.sendRequest('mutation{updateUser (dashboard: "' + escape(JSON.stringify(this.dashboards)) + '") {dashboard}}')
          .then(response => {
                this.dashboards = JSON.parse(response.updateUser.dashboard);
                this.initEditing()
              }
          )
    },
    initEditing() {
      this.editMode = true;
      this.dashboards.content = this.del(this.dashboards, "add_dashlet")
      this.dashboards.content.push({
        id: "add_dashlet",
        type: "dashlet",
        width: "width-full",
        dashlet: "add_dashlet"
      });
    },
    swap(id, direction) {
      let originalIndex = 0;
      this.dashboards.content.forEach(function (d, index) {
        if (d.id === id)
          originalIndex = index;
      });

      if (originalIndex + direction >= 0 && originalIndex + direction <= this.dashboards.content.length - 1) {
        [this.dashboards.content[originalIndex], this.dashboards.content[originalIndex + direction]]
            = [this.dashboards.content[originalIndex + direction], this.dashboards.content[originalIndex]]
        const newContent = this.dashboards.content;
        this.dashboards.content = [];
        this.dashboards.content = newContent
      }
    },
    del(obj, id) {
      if (obj.content)
        return obj.content = obj.content.filter((d) => {
          if (d.content) this.del(d, id)
          return d.id !== id
        })
    },
    exportData() {
      console.log("Date Range:", this.filters.dateRange);  // Log to verify date range

      let v = [];
      this.filters.venues.forEach(function (venue) { 
        v.push(venue.id);
      });

      let params = (this.filters.venues.length > 0 ? 'venues:["' + v.join('","') + '"],' : '') +
          'startDate: "' +  moment(this.filters.dateRange.startDate).format("YYYY-MM-DD 00:00:00") + '", ' +
          'endDate: "' + moment(this.filters.dateRange.endDate).format("YYYY-MM-DD 23:59:59") + '"';

      GraphQl.sendRequest('{organization(id:"' + this.orgId + '") {accessPointsCount venuesCount connectionsCount(' + params + ')' +
          ' customersCount(' + params + ') onlineConnectionsCount(' + params + ')}' +
          'aggregateUsageSummary(' + params + '){formattedUpload formattedDownload formattedBandwidth new_customers repeat_customers connections footfall dwell_time abandoned avg_dwell_time}}')
          .then(response => {
            this.organization = response.organization;
            this.summary = response.aggregateUsageSummary;
          })


          console.log('Summary Data:', this.summary);  // Ensure this has the expected data


  // Ensure filters.dateRange is up-to-date
  const startDate = moment(this.filters.dateRange.startDate).format("YYYY-MM-DD");
  const endDate = moment(this.filters.dateRange.endDate).format("YYYY-MM-DD");

  // Initialize data array for CSV
  const data = [];

  // Add the start and end date as a header section
  data.push(["Date Range"]);
  data.push(["Start Date:", startDate]);
  data.push(["End Date:", endDate]);
  data.push([]); // Empty row to separate date range from main data

  data.push(["Total Bandwidth:", this.summary.formattedBandwidth]);
  data.push(["Upload:", this.summary.formattedUpload]);
  data.push(["Download:", this.summary.formattedDownload]);

  data.push([]); // Empty row to separate date range from main data

  data.push(["Guests:", this.summary.repeat_customers + this.summary.new_customers]);
  data.push(["New Guests:", this.summary.new_customers]);
  data.push(["Repeat Guests:", this.summary.repeat_customers]);

  data.push([]); // Empty row to separate date range from main data

  data.push(["Footfall:", this.summary.footfall]);
  data.push(["Total Successful Connections:", this.summary.connections]);
  data.push(["Total Abandoned Connections:", (this.summary.footfall - this.summary.connections)]);

  // Convert data to CSV format
  const csvContent = data.map(e => e.join(",")).join("\n");

  // Create a downloadable link
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.setAttribute("download", `dashboard_summary_data_${startDate}_to_${endDate}.csv`);

  // Append link to the document and simulate click
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
},
    convertToCSV(data) {
      const array = [Object.keys(data[0])].concat(data);
      return array.map(row => {
        return Object.values(row).map(value => 
          typeof value === "string" ? `"${value.replace(/"/g, '""')}"` : value
        ).join(",");
      }).join("\r\n");
    }
  }
}
</script>

<style>
.vue-daterange-picker {
  height: 100%;
}

input:checked + svg {
  display: block;
}

.form-control {
  display: block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #ffffff !important;
  background-clip: padding-box;
  border: 1px solid #e8e8e8 !important;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.reportrange-text {
  width: 100%;
  height: 100%;
  padding: 10px 10px 8px 10px !important;
}

.vue-daterange-picker {
  width: 100%;
}

.btn-success {
  color: #fff;
  background-color: #28a745;
  border-color: #28a745;
  cursor: pointer;
  padding: 0.5rem 1rem;
  font-size: 1rem;
  border-radius: 0.25rem;
  transition: background-color 0.3s ease;
}

.btn-success:hover {
  background-color: #218838;
}

</style>
